import { Flow } from 'constants/flowConstants'

export const resolveParam = (param) => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  return urlSearchParams.get(param)
}

export const resolveCompletionUrl = (flow) => {
  switch (flow) {
    case Flow.SALES:
      return '/activity'
    case Flow.SALES_MANAGER:
      return '/reports/real-time'
    case Flow.MARKETER:
      return '/playbooks'
    default:
      return '/'
  }
}
